module.exports = __webpack_public_path__ + "static/right-floating-land-e3b07613cf4a3e0f3e011ac1b4449398.svg";